import { QuoteToolModes } from './quote-tool-modes.enum';

export const quoteToolPaths = new Map<QuoteToolModes, string>([
  [QuoteToolModes.wizard, 'quote'],
  [QuoteToolModes.form, 'free-quote'],
  [QuoteToolModes.enrollment, 'book-now'],
  [QuoteToolModes.priceRequest, 'price-request'],
  [QuoteToolModes.quickQuoteTool, 'quick-quote-tool'],
]);
